$(document).ready(function(){
    $('.featured-content-grid-container[ajax-config]').each(function(){
        var $self = $(this);
        var ajaxConfig = JSON.parse($self.attr('ajax-config') || '{}');
        var $loadMoreBtn = $self.find('.fcg-load-more-btn');

        $loadMoreBtn.on('click', function () {
            var existingIds = [];
            //add class to button
            $loadMoreBtn.addClass('btn-disabled');
            //get existing IDs
            $.each($self.find('div[data-pid]'), function (i, el) { 
                existingIds.push($(el).attr('data-pid'));
            });
            //pass as parameter in post__not_in
            $.ajax({
				url: ajaxConfig.url,
				method: 'GET',
				data: {
					action: ajaxConfig.action,
					post__in: ajaxConfig.post__in,
					post__not_in : existingIds,
				},
				dataType: 'json'
			}).done(function(resp) {
                resp.forEach(function(el){
                    $(el).insertBefore($loadMoreBtn);
                });
                if(resp.count < 10){
                    $loadMoreBtn.hide();
                }
			}).fail(function(jqXHR, textStatus, errorThrown) {
				console.log('There was an error processing your search, please try again later.');
			}).always(function() {
				$loadMoreBtn.removeClass('btn-disabled');
			});
            //run ajax
            //paste results in container
        });
    });
})